import { useState, useEffect } from "react";
import { getCountryDetails } from "../services/configurationServices";


export const useCountry = () => {

    const [country, setCountry] = useState([]);
    const getCountry = () => {
        try {
            let obj = {
                type: "CountryMaster",
            };
            getCountryDetails(obj).then((resp) => {
                if (resp != undefined) {
                    if (resp.Status == "success") {
                        setCountry(resp.Data);
                    } else {
                        setCountry([]);
                    }
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getCountry();           
    }, []);

    return { country, setCountry, getCountry }
}

